export const isCommissionEnabled = (item) => {
  const value = item?.apply_commission;

  if (value === undefined || value === null) {
    return true;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    if (["0", "false", "no", "off"].includes(normalized)) {
      return false;
    }

    if (["1", "true", "yes", "on"].includes(normalized)) {
      return true;
    }

    return Boolean(normalized);
  }

  return Boolean(value);
};

export const commissionLabel = "Keine Provision";
